<template>
  <div>
    <div v-if="errors.length > 0" role="alert" class="alert alert-warning">
      <div v-for="(v, k) in errors" :key="k">
        <div v-for="error in v" :key="error" class="text-sm">
          {{ error }}
        </div>
      </div>
    </div>
      <div class="file-upload-wrapper">
        <input type="file" class="file-input-hidden" ref="fileInput" accept="image/*, application/pdf" @change="fileUpload"/>
        <button class="btn btn-block mb-2 btn-primary button-upload" @click="$refs.fileInput.click()">Upload Application
        </button>
        <div class="invalid-tooltip">Please upload file</div>
        <div class="col-12 col-sm-6 mb-3 pl-xl-4 form-group file-name">
          {{ file_name || 'Choose file...' }}
          <button v-if="file_name" type="button"
                  class="btn btn-link" @click="deleteAttachment">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" aria-hidden="true" viewBox="0 0 17 17">
                <g fill="currentColor">
                  <path
                    d="M8.5 17C3.8 17 0 13.2 0 8.5S3.8 0 8.5 0 17 3.8 17 8.5 13.2 17 8.5 17zm0-16C4.4 1 1 4.4 1 8.5S4.4 16 8.5 16 16 12.6 16 8.5 12.6 1 8.5 1z"/>
                  <path
                    d="M10.6 11.1c-.1 0-.3 0-.4-.1L6 6.8c-.2-.2-.2-.5 0-.7s.5-.2.7 0l4.2 4.2c.2.2.2.5 0 .7-.1 0-.2.1-.3.1z"/>
                  <path
                    d="M6.4 11.1c-.1 0-.3 0-.4-.1-.2-.2-.2-.5 0-.7l4.2-4.2c.2-.2.5-.2.7 0s.2.5 0 .7L6.7 11s-.2.1-.3.1z"/>
                </g>
              </svg>
            </div>
          </button>
        </div>
      </div>
    <div @change="resetErrors">
      <div class="row">
        <div class="col-12 col-md-6 pr-xl-4 form-group">
          <label :for="user_id">Member to Apply For</label>
          <select class="form-control" id="user_id" v-model="user_id" required :disabled="!!this.$route.params.member_id">
            <option disabled></option>
            <option v-for="(member, memberIndex) in membersSelect" :key="memberIndex" :value="member.id">{{
                member.name
              }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 pr-xl-4 form-group">
          <label :for="status">Status</label>
          <input type="text" class="form-control" id="status"  style="text-transform: capitalize;" disabled
                 :value="[($route.params.member_id) ? applicationTypes.OPEN_TYPE : applicationTypes.TRIAL_TYPE]">
        </div>
        <div class="col-12 col-md-6 pr-xl-4 form-group ">
          <label>Phone Number</label>
          <input type="text" class="form-control" :value="selectedMemberData.phoneNumber" required disabled>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 pr-xl-4 form-group ">
          <label :for="additional_email">Additional Judge Email</label>
          <input type="text" class="form-control" id="additional_email" v-model="additional_email">
        </div>
        <div class="col-12 col-md-6 pr-xl-4 form-group ">
          <label :for="additional_phone">Additional Judge Phone</label>
          <phone-input id="additional_phone" v-model="additional_phone" />
          <small>Please enter the phone in a similar format +614 **** **** without spaces</small>
          <test-phone-numbers />
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 pr-xl-4 form-group">
          <label>Suburb</label>
          <select class="form-control" required disabled>
            <option disabled></option>
            <option>{{ selectedMemberData.suburb }}</option>
          </select>
        </div>
        <div class="col-12 col-md-6 pr-xl-4 form-group">
          <label>Zone</label>
          <select class="form-control" required disabled>
            <option disabled></option>
            <option>{{ selectedMemberData.zoneCode }}</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-12 form-group">
          <div class="form-group form-check px-0 mb-sm-4">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="is_call_first" v-model="is_call_first">
              <label class="custom-control-label" for="is_call_first">
                I would like to appear on the Call First list on the ACA Judges Register
              </label>
            </div>
            <div class="col-6 small-text">
              By selecting this box you acknowledge you are happy to be approached by committees first who are seeking
              judges for their event
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 form-group">
          <button class="btn btn-block mb-2 btn-primary button-submit" @click="create">Send Application</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from "axios"
import { applicationTypes } from '@/views/Judges/constants.js'
import PhoneInput from '@/components/FormFields/PhoneInput'
import TestPhoneNumbers from '@/components/TestPhoneNumbers'

export default {
  components: { TestPhoneNumbers, PhoneInput },
  name: "JudgeApplicationForm",
  props: ['memberDetails'],

  data() {
    return {
      user_id: this.$route.params.member_id ? this.$route.params.member_id : null,
      file: '',
      file_name: null,
      additional_email: null,
      additional_phone: null,
      is_call_first: false,
      type: null,
      status: null,
      errors: [],
      applicationTypes
    }
  },
  computed: {
    membersSelect() {
      const secondaries = this.memberDetails.secondaries.map(secondary => ({
        id: secondary.id,
        name: `${secondary.first_name} ${secondary.last_name}`,
        phoneNumber: secondary.secondary_phone || '',
        zoneCode: this.memberDetails.attributes && this.memberDetails.attributes.zone ? this.memberDetails.attributes.zone.code : '',
        suburb: this.memberDetails.attributes && this.memberDetails.attributes.address.suburb ? this.memberDetails.attributes.address.suburb : '',
        isFinancial: (secondary.financial && !secondary.has_event_membership) || false
      }))

      return [
        {
          id: this.memberDetails.id,
          name: `${this.memberDetails.first_name} ${this.memberDetails.last_name}`,
          phoneNumber: this.memberDetails.attributes.phone || '',
          zoneCode: this.memberDetails.attributes && this.memberDetails.attributes.zone ? this.memberDetails.attributes.zone.code : '',
          suburb: this.memberDetails.attributes && this.memberDetails.attributes.address.suburb ? this.memberDetails.attributes.address.suburb : '',
          isFinancial: (this.memberDetails.financial && !this.memberDetails.has_event_membership) || false
        },
        ...secondaries
      ]
    },
    judgeStatusesSelect() {
      return [
        { id: 0, title: applicationTypes.TRIAL_TYPE },
        { id: 1, title: applicationTypes.OPEN_TYPE }
      ]
    },
    selectedMemberData() {
      if (this.user_id) return this.membersSelect.find(member => member.id === Number(this.user_id))
      return ''
    }
  },
  methods: {
    fileUpload(event) {
      this.removeError('file')
      const uploadedFile = event.target.files[0]
      this.file = uploadedFile
      if (uploadedFile) {
        this.file_name = uploadedFile.name
      }
    },
    deleteAttachment() {
      this.removeError('file')
      delete this.file
      this.file = undefined
      this.file_name = ''
    },
    putErrors(errorField, errorMessage) {
      if (!this.errors.find(error => error[errorField])) this.errors.push({ [errorField]: errorMessage })
    },
    removeError(errorField) {
      this.errors = this.errors.filter(error => !error[errorField])
    },
    resetErrors() {
      this.errors = []
    },
    checkForm() {
      this.errors = []
      if (!this.user_id) this.putErrors('member', 'Member is required.')
      if (this.user_id) this.checkIsFinancial()
      if (!this.file) this.putErrors('file', 'File is required.')
      if (this.file && this.file.size > 1024 * 1024) this.putErrors('file', 'File may not be greater than 1 mb.')
    },
    checkIsFinancial() {
      const current = this.membersSelect.find(member => member.id === Number(this.user_id))
      if (!current.isFinancial) this.putErrors('member', 'Please pay ACA membership to apply for a Judge position.')
    },
    create() {
      this.checkForm()
      if (this.errors.length === 0) {
        this.processing = true

        const data = {
          user_id: this.user_id,
          file_name: this.file_name,
          additional_email: this.additional_email,
          additional_phone: this.additional_phone,
          is_call_first: this.is_call_first,
          type: (this.$route.params.member_id) ? applicationTypes.OPEN_TYPE : applicationTypes.TRIAL_TYPE
        }

        const formData = new FormData()
        formData.append('file', this.file)
        formData.append('fields', JSON.stringify(data))
        axios.post(`${this.$api}/judges/application`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
          .then((response) => {
            this.processing = false
            if (response.data.status === 'success') {
              this.$router.push({
                name: 'Judges Dashboard',
                params: {
                  success: 'Thanks for your application! Your application will be considered at the next ACA Management Committee meeting and you will be advised on the outcome within five (5) business days.'
                }
              })
            } else if (response.data.status === 'application_exists') {
              this.putErrors('common', 'Application already exists.')
            } else if (response.data.status === 'undefined_error') {
              this.putErrors('common', 'Something went wrong.')
            } else if (response.data.status === 'forbidden') {
              this.putErrors('common', 'This type of application is not available for this user')
            } else if (response.data.status === 'validation_error') {
              if (response.data.errors && response.data.errors.user_id) this.putErrors('member', 'Member is required.')
              if (response.data.errors && response.data.errors.additional_email) this.putErrors('email', 'The additional email must be a valid email address.')
              if (response.data.errors && response.data.errors.additional_phone) this.putErrors('phone', 'Please enter valid mobile number.')
              if (response.data.errors && response.data.errors.user_id) this.putErrors('member', 'Member is required.')
            } else if (response.data.status === 'judge_is_suspended' && response.data.errors) {
              this.putErrors('common', 'The judge is suspended')
            } else {
              this.success = ''
            }
          })
          .catch(() => {
            this.success = ''
            this.putErrors('common', 'Something went wrong.')
            this.processing = false
          })
      }
    }
  }
}
</script>

<style scoped>
.file-upload-wrapper {
  display: flex;
  align-items: baseline;
  margin-bottom: 15px;
}

.button-upload {
  width: 220px;
}

.button-submit {
  width: 220px;
}

.small-text {
  font-size: 85%;
  font-weight: 400;
  padding-left: 28px;
}

.file-input-hidden {
  display: none;
}

.file-name {
  display: flex;
  align-items: baseline;
}
</style>



// WEBPACK FOOTER //
// src/views/Judges/Application/components/JudgeApplicationForm.vue